<template>
  <div id="main-content">
    <section id="home-section">
      <div class="home-brand-panel description container">
        <div class="home-info">
          <div class="home-brand">DOO3D Examples</div>
          <div class="home-subtitle">GPU分布式并行计算的3D数字孪生技术开发平台</div>
          <div class="home-btn-panel">
            <router-link
              :to="link.editor"
              class="btn btn-main btn-index-home"
            >
              <svg
                width="22px"
                height="19px"
                viewBox="0 0 17 22"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="index-home-svg"
              >
                <path
                  fill="#fff"
                  d="M10.9,16.2 C10.9,16.8 10.5,17.2 9.9,17.2 L5.3,17.2 C4.7,17.2 4.3,16.8 4.3,16.2 C4.3,15.6 4.7,15.2 5.3,15.2 L9.9,15.2 C10.5,15.2 10.9,15.7 10.9,16.2 Z M13.6,7.5 L5.3,7.5 C4.7,7.5 4.3,7.9 4.3,8.5 C4.3,9.1 4.7,9.5 5.3,9.5 L13.6,9.5 C14.2,9.5 14.6,9.1 14.6,8.5 C14.6,7.9 14.2,7.5 13.6,7.5 Z M17.9,6 L17.9,19 C17.9,20.7 16.6,22 14.9,22 L3.9,22 C2.2,22 0.9,20.7 0.9,19 L0.9,7.5 L0.9,6 L0.9,5 L0.9,4 L0.9,2 C0.9,0.9 1.8,0 2.9,0 L12.9,0 C14,0 14.9,0.9 14.9,2 L14.9,3 C16.6,3 17.9,4.3 17.9,6 Z M2.9,3 L3.9,3 L12.9,3 L12.9,2 L2.9,2 L2.9,3 Z M15.9,6 C15.9,5.4 15.5,5 14.9,5 L3.9,5 C3.3,5 2.9,5.4 2.9,6 L2.9,19 C2.9,19.6 3.3,20 3.9,20 L14.9,20 C15.5,20 15.9,19.6 15.9,19 L15.9,6 Z M13.6,11.5 L5.3,11.5 C4.7,11.5 4.3,11.9 4.3,12.5 C4.3,13.1 4.7,13.5 5.3,13.5 L13.6,13.5 C14.2,13.5 14.6,13.1 14.6,12.5 C14.6,11.9 14.2,11.5 13.6,11.5 Z"
                ></path>
              </svg><span>快速使用</span>
            </router-link>
            <router-link
              :to="link.examples"
              class="btn btn-main btn-index-home"
            ><svg
                width="25px"
                height="19px"
                viewBox="0 0 17 22"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="index-home-svg"
              >
                <path
                  fill="#337ab7"
                  d="M21,0 L6,0 C4.9,0 4,0.9 4,2 L4,4 L2,4 C0.9,4 0,4.9 0,6 L0,18 C0,19.1 0.9,20 2,20 L17,20 C18.1,20 19,19.1 19,18 L19,16 L21,16 C22.1,16 23,15.1 23,14 L23,2 C23,0.9 22.1,0 21,0 Z M17,18 L2,18 L2,6 L17,6 L17,18 Z M21,14 L19,14 L19,6 C19,4.9 18.1,4 17,4 L6,4 L6,2 L21,2 L21,14 Z M4,15 L4,12 C4,11.4 4.4,11 5,11 C5.6,11 6,11.4 6,12 L6,15 C6,15.6 5.6,16 5,16 C4.4,16 4,15.6 4,15 Z M13,15 L13,12 C13,11.4 13.4,11 14,11 C14.6,11 15,11.4 15,12 L15,15 C15,15.6 14.6,16 14,16 C13.4,16 13,15.6 13,15 Z M7,15 L7,9 C7,8.4 7.4,8 8,8 C8.6,8 9,8.4 9,9 L9,15 C9,15.6 8.6,16 8,16 C7.4,16 7,15.6 7,15 Z M10,15 L10,11 C10,10.4 10.4,10 11,10 C11.6,10 12,10.4 12,11 L12,15 C12,15.6 11.6,16 11,16 C10.4,16 10,15.6 10,15 Z"
                ></path>
              </svg><span>所有示例</span></router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return { link: {editor:'./editor', examples:'./examples'}, event_show: true };
  },
  methods: {},
  mounted() {
    // 注册监听事件
    let scope = this;
    this.emit.on("event_bus", function (bShow) {
      console.log("event_bus", bShow);
      scope.event_show = bShow;
    });
  },
  unmounted() {
    //移除监听事件
    this.emit.off("event_bus");
  },
};
</script>

<style scoped>
#main-content {
  position: absolute;
  left: 0;
  top: 50px;
  right: 0;
  bottom: 0;
}

#main-content .index-home-svg {
  position: relative;
  top: 4px;
  left: -6px;
}

#main-content .home-info {
  margin-top: 20%;
}

#main-content .home-brand {
  font-size: 75px;
  font-weight: 800;
  color: #081642;
  line-height: 1.2em;
}

#main-content .container {
  width: 1170px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

#main-content .home-subtitle {
  font-size: 21px;
  color: #1d2b5a;
  margin-top: 15px;
}

#main-content .home-btn-panel {
  margin-top: 40px;
}

#main-content .btn-index-home:first-child {
  background-color: #53a8ff;
  color: #fff;
  opacity: 1;
}

#main-content .btn-index-home {
  min-width: 150px;
  padding: 15px 10px;
  border-radius: 30px;
  background-color: #fff;
  border: 1px solid #53a8ff;
  color: #53a8ff;
  opacity: 0.8;
  font-size: 16px;
}

#main-content .btn-index-home:first-child {
  background-color: #53a8ff;
  color: #fff;
  opacity: 1;
}

#main-content .btn-index-home:first-child .index-home-svg {
  left: -3px;
  top: 3px;
}

#main-content .btn-index-home:hover,
#main-content .btn-index-home:focus {
  -webkit-box-shadow: 0px 5px 10px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0px 5px 10px 0 rgba(0, 0, 0, 0.2);
}

.btn-main + .btn {
  margin-left: 15px;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

a {
  color: #337ab7;
  text-decoration: none;
}
</style>
